
  import React, { useState, useEffect } from "react";
  import Modal from "@material-ui/core/Modal";
  import Backdrop from "@material-ui/core/Backdrop";
  import Fade from "@material-ui/core/Fade";
  import { NavLink } from "react-router-dom";
  import Grid from "@material-ui/core/Grid";
  import { makeStyles } from "@material-ui/core/styles";
  const useStyles = makeStyles((theme) => ({
    title: {
      marginTop: 0,
    },
    field: {
      width: "100%",
      marginBottom: "1rem",
    },
    autoComplete: {
      width: "100%",
      marginTop: "0",
      marginBottom: "0.5rem",
    },
    date: {
      width: "100%",
      marginBottom: "1rem",
    },
    buttonContainer: {
      textAlign: "right",
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      maxWidth: "1000px",
      margin: "0 auto",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      width: "800px",
    },
    button: {
      textAlign: "right",
      marginTop: "30px",
      "& .MuiButton-containedPrimary": {
        marginRight: "10px",
      },
    },
  
    buttonMarginRight: {
      marginRight: "0.5rem",
    },
  }));

  export default function PackageSavedModal({show, link, caption}) {
    const classes = useStyles();
    return (
      <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={show}
      onClose={show}
      closeAfterTransition
    >
      <Fade in={show}>
        <div className={classes.paper}>
          <h2 id="transition-modal-title" style={{color:'green'}}>Package Save Successfully!</h2>
          <form action="" className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
              Do you want to add more packages? or proceed to Transaction History
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <NavLink to={'/package-sales'} key={206}>
                      <div className="app-card">
                        Add more package
                      </div>
                    </NavLink>
                  </Grid>
                  <Grid item xs={6}>
                    {/* <NavLink to={"/package-sales-summary"+ "/" + 0} key={219}> */}
                    <NavLink to={link} key={219}>
                      <div className="app-card">
                        {caption}
                      </div>
                    </NavLink>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </div>
      </Fade>
    </Modal>
    );
  }